import { useAssistantRecentConvosQuery } from '~/lib/Queries';
import { truncate } from '~/lib/Utils.js';

const SingleConvo = ({ convo, onSelect }) => {
    return (
        <button
            className={`cursor-pointer py-2 px-4 rounded-xl hover:bg-[#EAEDF3]`}
            onClick={() => onSelect(convo.results)}
        >
            {truncate(convo.results[0].content, 100)}
        </button>
    );
};

const AssistantRecentConvos = ({ onSelect, className }) => {
    const { data } = useAssistantRecentConvosQuery();

    if (!data?.length) {
        return null;
    }

    return (
        <>
        <div className={`panel ${className}`}>
            <div className="">
                {data?.map((convo, idx) => (
                    <SingleConvo key={idx} convo={convo} onSelect={onSelect} />
                ))}
            </div>
        </div>
        </>
    );
};

export default AssistantRecentConvos;
